const INTERNAL_PARENT_PREFIX = "__UNIT_PARENT__:";

export function isInternalParentBarcode(barcode) {
  return String(barcode || "").startsWith(INTERNAL_PARENT_PREFIX);
}

function activeUnits(item) {
  return (item.product_units || []).filter((unit) => unit.is_active !== false);
}

export function getInventoryBarcodeDisplay(item, search = "") {
  if (!item.unit_inventory_enabled && !isInternalParentBarcode(item.barcode)) {
    return { primary: item.barcode || "-", additionalCount: 0 };
  }

  const units = activeUnits(item);
  const normalizedSearch = String(search || "").trim().toLowerCase();
  const matchedUnit = normalizedSearch
    ? units.find((unit) =>
        String(unit.barcode || "").toLowerCase().includes(normalizedSearch))
    : null;
  const primaryUnit =
    matchedUnit ||
    units.find((unit) => unit.is_base_unit) ||
    units.find((unit) => unit.can_sell !== false) ||
    units[0];

  return {
    primary: primaryUnit?.barcode || "No unit barcode",
    additionalCount: Math.max(0, units.length - (primaryUnit ? 1 : 0)),
  };
}

export function inventoryItemMatchesSearch(item, search) {
  const normalizedSearch = String(search || "").trim().toLowerCase();
  if (!normalizedSearch) return true;

  if (String(item.name || "").toLowerCase().includes(normalizedSearch)) {
    return true;
  }

  if (
    !isInternalParentBarcode(item.barcode) &&
    String(item.barcode || "").toLowerCase().includes(normalizedSearch)
  ) {
    return true;
  }

  return activeUnits(item).some((unit) =>
    String(unit.barcode || "").toLowerCase().includes(normalizedSearch),
  );
}
